import { IconComponent } from './types';

const CropIcon: IconComponent = (props) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.1044 6.14229C2.30864 6.16233 0.663152 5.677 1.05693 1C5.60122 1.23498 6.33901 2.61383 6.1044 6.14229Z"
      stroke="currentColor"
    />
    <path
      d="M7.46701 6.14229C11.2628 6.16233 12.9083 5.677 12.5145 1C7.97019 1.23498 7.2324 2.61383 7.46701 6.14229Z"
      stroke="currentColor"
    />
    <line
      x1="6.64288"
      y1="4.85714"
      x2="6.64288"
      y2="10"
      stroke="currentColor"
    />
    <line x1="2.28571" y1="9.5" x2="11.2857" y2="9.5" stroke="currentColor" />
  </svg>
);

export default CropIcon;
